import './react/index.jsx'
import './scss/style.scss'

// import './js/vendors/tinydatepicker.js'
import './js/scripts/common.js'
import './js/scripts/dev.js'

